// src/components/FtuDateInput.tsx
import React from "react";
import DatePicker from "react-datepicker";
import { IconCalendar } from "@tabler/icons-react";
import "react-datepicker/dist/react-datepicker.css";
interface FtuDateInputProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
}

const FtuDateInput: React.FC<FtuDateInputProps> = ({
  value,
  onChange,
  placeholder = "dd/mm/yyyy",
  minDate,
  maxDate,
}) => {
  return (
    <div className="w-full flex flex-col gap-1.5">
      <div className="relative flex items-center bg-white rounded-lg">

        <DatePicker
          popperClassName="z-10"
          selected={value}
          onChange={onChange}
          showYearDropdown
          showMonthDropdown
          dropdownMode="select"
          placeholderText={placeholder}
          dateFormat="dd/MM/yyyy"
          minDate={minDate}
          maxDate={maxDate}
          className="
            w-full
            px-4 py-3 sm:px-3.5 sm:py-2.5
            pr-12 sm:pr-10
            border border-[#e5e7eb] rounded-lg
            font-sans text-base sm:text-sm
            text-[#1e1e1e]
            bg-white outline-none
            transition
            focus:border-[#1e5e5b] focus:ring-4 focus:ring-[rgba(30,94,91,0.10)]
            placeholder:text-[#b3b3b3] placeholder:font-normal
          "
          wrapperClassName="w-full"
          
        />

        <IconCalendar
          size={24}
          strokeWidth={1.5}
          className="absolute right-4 sm:right-3 text-[#6b7280] pointer-events-none"
        />
      </div>
    </div>
  );
};

export default FtuDateInput;
